import React, { useState } from 'react';
import { RequestAPI } from '../../../../api';
import { AdminPermissionAPI } from '../../../../api/admin_permission';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './NodeAuthorizationForm.form';
import { Container, Form, Header } from "semantic-ui-react";
import { PopupNodeAuthorizationFormSent } from './PopupNodeAuthorizationFormSent';
import { useAuth } from '../../../../hooks';
import './NodeAuthorizationForm.css';
import { isAddress } from 'web3-utils';
const requestController = new RequestAPI();
const adminPermissionController = new AdminPermissionAPI();

export function NodeAuthorizationFormOpen(props) {

    const { close, onReload, permission } = props;
    const { accessToken } = useAuth();
    const date = new Date().toLocaleDateString();
    
    const [showModal, setShowModal] = useState(false);
    const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

    const formik = useFormik({
        initialValues: initialValues(permission),
        validationSchema: validationSchema(permission),
        validateOnChange: false,
        onSubmit: async (formValue) => {
            try {
                if (permission) {
                    console.log(permission);
                    await adminPermissionController.updatePermission(accessToken, permission.id, formValue);
                    onReload();
                    close();
                } else {
                    console.log("formValue", formValue);
                    await requestController.createRequest(accessToken, formValue);
                    onOpenCloseModal();
                }
            } catch (error) {
                console.log(error);
            }
        },
        validate: async (values)=>{
            let errors = {};

           if(!values.addressNode){
             errors.addressNode= 'Required!'
            }else if(!isAddress(values.addressNode)){
           errors.addressNode = 'Invalid Address Node format!'
           }

           if(!values.enode){
            errors.enode= 'Required!'
           }else if(!isValidEnode(values.enode)){
          errors.enode = 'Invalid enode format!'
          }

            return errors;
        }  
    });
    const isValidEnode = (str) => {
        return !Object.values(enodeToParams(str)).some(value => !value);
    }
    const enodeToParams = (enodeURL) => {
        let enodeHigh = '';
        let enodeLow = '';
        let ip = '';
        let port = '';
        //let group = '';
      
        const splitURL = enodeURL.split('//')[1];
        if (splitURL) {
          const [enodeId, rawIpAndPort] = splitURL.split('@');
          if (enodeId && enodeId.length === 128) {
            enodeHigh = '0x' + enodeId.slice(0, 64);
            enodeLow = '0x' + enodeId.slice(64);
          }
          if (rawIpAndPort) {
            const [ipAndPort] = rawIpAndPort.split('?');
            if (ipAndPort) {
              [ip, port] = ipAndPort.split(':');
            }
          }
        }
        return {
          enodeHigh,
          enodeLow,
          ip: ip ? getHexIpv4(ip) : '',
          port,
         // group: '0x4BB48E76F19DE6EBED7D59D46800508030AECEA46BA56BD19855D94473E28BC0'
        }
    }
    function getHexIpv4(stringIp) {
        const splitIp = stringIp.split('.');
        return `0x00000000000000000000ffff${toHex(splitIp[0])}${toHex(splitIp[1])}${toHex(splitIp[2])}${toHex(splitIp[3])}`;
    }
    function toHex(number) {
        const num = Number(number).toString(16);
        return num.length < 2 ? `0${num}` : num;
    }
    const onAcceptReload = () => {
        formik.resetForm(initialValues(permission));
        onOpenCloseModal();
    }


    return (
    <>
        <Container className='contenedor'>
            <Header className='header' as='h1'>REGISTRATION AGREEMENT FOR NODE DEPLOYMENT</Header>
            
            <Form className='formulario' onSubmit={formik.handleSubmit}>
                <p>We understand that this is an agreement form required for tehe deployment of nodes in the LACChain Testnet networks orchestrated by LACNet.</p>
                {/* FIRST INFORMATION */}
                <Form.Input
                    className='inputs'
                    type="text" name="entity" id="entity"
                    label='Entity Name'
                    onChange={formik.handleChange}
                    value={formik.values.entity}
                    error={formik.errors.entity}
                />


                <Form.Input
                    className='inputs'
                    type="text" name="address" id="address"
                    label='Entity Address'
                    onChange={formik.handleChange}
                    value={formik.values.address}
                    error={formik.errors.address}
                />

                <p>TECHNICAL PERSON</p>
                <Form.Group className='groupTechContact'>
                    <Form.Input
                        className='inputsGroupTechContact'
                        type="text" name="nameTechnicalContact"
                        label='Name Technical Contact'
                        width={4}
                        onChange={formik.handleChange}
                        value={formik.values.nameTechnicalContact}
                        error={formik.errors.nameTechnicalContact}
                    />

                    <Form.Input
                        className='inputsGroupTechContact'
                        type="text" name="emailTechnicalContact"
                        label='Email Technical Contact'
                        width={4}
                        onChange={formik.handleChange}
                        value={formik.values.emailTechnicalContact}
                        error={formik.errors.emailTechnicalContact}
                    />

                    <Form.Input
                        className='inputsGroupTechContact'
                        type="text" name="phoneTechnicalContact"
                        label='Phone Technical Contact'
                        width={4}
                        onChange={formik.handleChange}
                        value={formik.values.phoneTechnicalContact}
                        error={formik.errors.phoneTechnicalContact}
                    />
                </Form.Group>

                <p>BUSSINES CONTACT</p>
                <Form.Group className='groupBussContact'>
                    <Form.Input
                        className='inputsGroupBussContact'
                        type="text" name="nameBussinesContact" id="nameBussinesContact"
                        label='Name Bussines Contact'
                        width={4}
                        onChange={formik.handleChange}
                        value={formik.values.nameBussinesContact}
                        error={formik.errors.nameBussinesContact}
                    />

                    <Form.Input
                        className='inputsGroupBussContact'
                        type="text" name="emailBussinesContact" id="emailBussinesContact"
                        label='Email Bussines Contact'
                        width={4}
                        onChange={formik.handleChange}
                        value={formik.values.emailBussinesContact}
                        error={formik.errors.emailBussinesContact}
                    />

                    <Form.Input
                        className='inputsGroupBussContact'
                        type="text" name="phoneBussinesContact" id="phoneBussinesContact"
                        label='Phone Bussines Contact'
                        width={4}
                        onChange={formik.handleChange}
                        value={formik.values.phoneBussinesContact}
                        error={formik.errors.phoneBussinesContact}
                    />
                </Form.Group>

               
                    <>
                        <p>NODE INFO</p>
                        <Form.Field className='nodeInfoFieldInputs'>
                            <Form.Input
                                className='nodeInfoFieldInputs__enode'
                                type='text' name='enode' id='enode'
                                label='ENODE'
                                placeholder='enode://23acce5851a148c31d4e3c25768e60549467b959e3ecc2eea84a5228cf72ce6d2b28ab995ef4caaa54f59338cb041bb249e5f41888154a62bd410831b4c07ca2@34.67.111.42:60606'
                                onChange={formik.handleChange}
                                value={formik.values.enode}
                                error={formik.errors.enode}
                            />

                            <Form.Input
                                className='nodeInfoFieldInputs__addressNode'
                                type='text' name='addressNode' id='addressNode'
                                label='ADDRESS NODE'
                                placeholder="0x40358e97111e82f958871acecf57f6e771edb3f5"
                                onChange={formik.handleChange}
                                value={formik.values.addressNode}
                                error={formik.errors.addressNode}
                            />
                        </Form.Field>
                    </>
               

                {/* MORE INFORMATION */}
                <p className='form-body_p2'>To provide the best assistance and support, as well identy the impact on social and financial inclusion that the project using 
                    the networks are having, we kindly request your help with the following information regarding the pojects to be deployed using the
                    requested node(s)
                </p>
                    <Form.Select
                        className='select'
                        name="confidentiality"
                        label='Confidentiality of information:'
                        options={confidentiality}
                        placeholder='Select'
                        onChange={(_, data) => formik.setFieldValue("confidentiality", data.value)}
                        value={formik.values.confidentiality}
                        error={formik.errors.confidentiality}
                    />

                    <Form.Input
                        className='inputsNumber'
                        type='number'
                        label='Number of projects to be deployed on the node:'
                        name='projectOnNode'
                        onChange={(_, data) => formik.setFieldValue("projectOnNode", data.value.toString())}
                        value={formik.values.projectOnNode}
                        error={formik.errors.projectOnNode}
                    />

                    <Form.Input
                        className='inputs'
                        type='text'
                        label='Name of each projects:'
                        name='nameProject'
                        onChange={formik.handleChange}
                        value={formik.values.nameProject}
                        error={formik.errors.nameProject}
                    />

                    <Form.Input
                        className='inputs'
                        type='text'
                        label='Participating countries:'
                        name='countries'
                        onChange={formik.handleChange}
                        value={formik.values.countries}
                        error={formik.errors.countries}
                    />

                    <Form.Input
                        className='inputs'
                        type='text'
                        label='Type of beneficiaries:'
                        name='typeBeneficiaries'
                        onChange={formik.handleChange}
                        value={formik.values.typeBeneficiaries}
                        error={formik.errors.typeBeneficiaries}
                    />

                    <Form.Input
                        className='inputsNumber'
                        type='number'
                        label='Number of beneficiaries:'
                        name='numberBeneficiaries'
                        onChange={(_, data) => formik.setFieldValue("numberBeneficiaries", data.value.toString())}
                        value={formik.values.numberBeneficiaries}
                        error={formik.errors.numberBeneficiaries}
                    />
                

                <Form.TextArea
                    className='textarea'
                    label='Please include a brief description of the projects:'
                    placeholder='Tell us more about the projects...'
                    name='descriptionProject'
                    style={{ minHeight: 100 }}
                    onChange={formik.handleChange}
                    value={formik.values.descriptionProject}
                    error={formik.errors.descriptionProject}
                />

                {/* SIGNATURE */}
                <p className='form-body_p3'>We hereby declare that we have read and agree with the <a href='https://github.com/LACNetNetworks/besu-networks/tree/master/testnet/terms_and_conditions'>
                    Terms and Conditions for LACChain Test Networks for Writer Nodes</a> operating in LACChain tESTNET networks orchestrated by LACNet.
                </p>

                { !permission ?
                    <Form.Checkbox
                        inline
                        label='I agree with all'
                        name='agree'
                        onChange={(_, data) => formik.setFieldValue("agree", data.checked ? "1" : "0")}
                        value={formik.values.agree}
                        error={formik.errors.agree}
                        required
                    /> :
                    <></>

                }
                

                <Form.Field>
                    <Form.Input
                        className='inputs_signature'
                        type='text'
                        label='Name:'
                        name='nameSignature'
                        onChange={formik.handleChange}
                        value={formik.values.nameSignature}
                        error={formik.errors.nameSignature}
                    />
                </Form.Field>
                

                <Form.Input
                    className='inputs_signature'
                    type='text'
                    label='Date :'
                    name='dateSignature'
                    readOnly
                    value={date}
                />

                <Form.Field>
                    <Form.Input
                        className='inputs_signature'
                        type='text'
                        label='Place:'
                        name='placeSignature'
                        onChange={formik.handleChange}
                        value={formik.values.placeSignature}
                        error={formik.errors.placeSignature}
                    />
                </Form.Field>
                

                { !permission ? 
                    <Form.Button className='button-permission' type="submit" primary fluid size='small' loading={formik.isSubmitting}>
                        {"Send"}
                    </Form.Button> : 
                    <Form.Group>
                        <Form.Button fluid className='button-permission' primary type='submit' loading={formik.isSubmitting}>{"Update"}</Form.Button>
                        <Form.Button fluid className='button-permission' secondary type='button' onClick={close}>{"Cancel"}</Form.Button>
                    </Form.Group>
                }
                

            </Form>
        </Container>

        <PopupNodeAuthorizationFormSent open={showModal} onAcceptReload={onAcceptReload}/>
    </>           
    );
}

const confidentiality = [
    {
        key: 'pr',
        text: 'Private',
        value: 'Private'
    },
    {
        key: 'pu',
        text: 'Public',
        value: 'Public'
    },
]